<style lang="scss" src="./style.scss" scoped></style>
<script src="./script"></script>
<template>
  <div class="page">
    <div class="container">
      <div class="form-container mt-5">
        <div class="card">
          <div class="card-body">
            <!-- LOGIN FORM -->
            <login v-if="tab == 'signin'" @return="onReturn($event)"/>

            <!-- CREATE NEW ACCOUNT -->
            <register v-if="tab == 'signup'" @return="onReturn($event)"></register>

            <!-- FORGET PASSWORD -->
            <reset-password v-if="tab == 'forget'" @return="onReturn($event)"></reset-password>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>